import mapboxgl from 'mapbox-gl'
import NavigationControl from './NavigationControl'
import Geocoder from './Geocoder'
import GeolocateControl from './GeolocateControl'
import FullscreenControl from './FullscreenControl'
import Marker from './Marker'
import MapboxLanguage from "../../lib/MapboxLanguage"
import DirectionsControl from "./DirectionsControl"

export default {
    mixins: [
        NavigationControl,
        Geocoder,
        GeolocateControl,
        FullscreenControl,
        Marker,
        DirectionsControl
    ],
    props: {
        accessToken: {
            type: String,
            required: true
        },
        mapStyle: {
            type: String,
            default: "mapbox://styles/mapbox/streets-v11"
        },
        dragPan: {
            type: Boolean,
            default: true
        },
        pitch: {
            type: Number,
            default: 0,
        },
        bearing: {
            type: Number,
            default: 0
        },
        minZoom: {
            type: Number,
            default: 0,
        },
        maxZoom: {
            type: Number,
            default: 23
        },
        cooperativeGestures: {
            type: Boolean,
            default: false
        },
        bounds: {
            type: Array,
            default: function () {
                return null
            }
        },
        backgroundPatternUrl: {
            type: String,
            default: ''
        },
        useMaplibre: {
            type: Boolean,
            default: false
        },
        useMapboxDirections: {
            type: Boolean,
            default: false
        },
        useGoogleMapDirections: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            mySmartMap: null,
            myMapStyle: this.mapStyle
        }
    },
    computed: {
        defaultConfig() {
            return {
                container: 'map',
                style: this.mapStyle,
                zoom: this.zoomLevel,
                center: this.coordinates,
                dragPan: this.dragPan,
                pitch: this.pitch,
                maxBounds: this.bounds,
                bearing: this.bearing,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                cooperativeGestures: this.cooperativeGestures,
                touchPitch: false
            }
        },
        currentMapLink() {
            return this.parcelMapLink || this.displayLink;
        },
    },
    methods: {
        loadMap() {
            mapboxgl.accessToken = this.accessToken
            this.mySmartMap = this.mySmartMap ? this.mySmartMap : new mapboxgl.Map(this.defaultConfig)
            this.handleGeoCoder()
            this.handleLocateUser()
            this.handleFullscreen()
            this.handleMarker()
            this.handleCompass()
            this.initDirectionsControl(this.accessToken);
        },
        initBackgroundPattern() {
            if (!this.backgroundPatternUrl) return;

            var self = this;
            this.mySmartMap.on('load', function () {
                self.mySmartMap.loadImage(self.backgroundPatternUrl, (error, image) => {
                    if (error) throw error;
                    self.mySmartMap.addImage('custom-background', image);
                });
                self.mySmartMap.addLayer({
                    id: 'bg-layer',
                    type: 'background',
                    paint: {
                        'background-pattern': 'custom-background'
                    }
                });
            });
        },
        switchLanguage(lang) {
            if (this.useMaplibre) {
                return;
            }
            lang = lang == 'zh-TW' ? 'zh-Hant' : (lang == 'zh-CN' ? 'zh-Hans' : lang);
            var mapboxlanguage = new MapboxLanguage();
            this.mySmartMap.off('styledata', this.switchLanguage);
            this.mySmartMap.setStyle(
                mapboxlanguage.setLanguage(this.mySmartMap.getStyle(), lang)
            )
        },
    },
    watch: {
        mapStyle(newVal) {
            this.mySmartMap.setStyle(newVal)
        },
        myMapStyle(newVal) {
            this.mySmartMap.setStyle(newVal)
        },
        pitch(newVal) {
            this.mySmartMap.setPitch(newVal);
        },
        bearing(newVal) {
            this.mySmartMap.setBearing(newVal);
        },
        minZoom(newVal) {
            this.mySmartMap.setMinZoom(newVal);
        },
        maxZoom(newVal) {
            this.mySmartMap.setMaxZoom(newVal);
        },
        backgroundPatternUrl(newVal) {
            if (newVal) {
                this.mySmartMap.loadImage(newVal, (error, image) => {
                    if (error) throw error;

                    if (this.mySmartMap.hasImage('custom-background')) {
                        this.mySmartMap.removeImage('custom-background');
                        this.mySmartMap.addImage('custom-background', image);
                    } else {
                        this.mySmartMap.addImage('custom-background', image);
                    }

                    if (!this.mySmartMap.getLayer('bg-layer')) {
                        this.mySmartMap.addLayer({
                            id: 'bg-layer',
                            type: 'background',
                            paint: {
                                'background-pattern': 'custom-background'
                            }
                        });
                    } else {
                        this.mySmartMap.setPaintProperty('bg-layer', 'background-pattern', 'custom-background');
                    }
                });
            } else {
                if (this.mySmartMap.getLayer('bg-layer')) {
                    this.mySmartMap.setPaintProperty('bg-layer', 'background-pattern', '');
                }
            }
        },
    },
    mounted() {
        if (!this.useMaplibre) {
            this.loadMap();
        }
    },
}
